import { render, staticRenderFns } from "./children.vue?vue&type=template&id=3b71bbf3&scoped=true&"
import script from "./children.vue?vue&type=script&lang=js&"
export * from "./children.vue?vue&type=script&lang=js&"
import style0 from "./children.vue?vue&type=style&index=0&id=3b71bbf3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b71bbf3",
  null
  
)

export default component.exports